export default "__VITE_ASSET__Cj7X8RLb__"